module.exports = __webpack_public_path__ + "static/media/price2_Blue.980cb990.png";